import React, { memo, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  IncidentCreateModal,
  IncidentShowMoreModal,
} from '../../../../components/Incidents/IncidentModals';
import moment from 'moment';
import { Callout, DirectionalHint } from '@fluentui/react';
import {
  closeModal,
  ModalSliceType,
  openModal,
} from '../../../../redux/slices/modal';
import { useAppSelector } from '../../../../redux/hooks';
import {
  selectModalData,
  selectOpenedModalType,
} from '../../../../redux/selectors/modal';

export default memo(function DateCellWrapper(props: any) {
  const { value, children } = props;
  const {
    props: { className },
  } = children;

  const dispatch = useDispatch();

  const triggerReference = useRef<any>(null);

  const isCreateIncidentPopupOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.IncidentCreate, value),
  );

  const onCreateIncidentPopupOpen = () =>
    dispatch(openModal({ id: value, type: ModalSliceType.IncidentCreate }));

  const isShowMoreModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.IncidentShowMore, ''),
  );

  const modalData = useAppSelector(selectModalData);
  const showMoreModalDate = modalData?.date;

  const isShowMorePopupOpenAndDateCorrect = useMemo(
    () =>
      isShowMoreModalOpen &&
      moment(value).isSame(moment(showMoreModalDate), 'day'),
    [isShowMoreModalOpen, showMoreModalDate, value],
  );

  const createIncidentTriggerClassNames = useMemo(
    () => `${className} ${isCreateIncidentPopupOpen && 'dirty'}`,
    [className, isCreateIncidentPopupOpen],
  );

  const onCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <div ref={triggerReference} className={createIncidentTriggerClassNames}>
      <div
        onClick={onCreateIncidentPopupOpen}
        style={{ width: '100%', height: '100%' }}
      />
      {/*
        fluent-ui/react Callout will render an extra span when open.
        It brakes markup a little bit. That's why we have an empty div above
      */}
      {isCreateIncidentPopupOpen && (
        <Callout
          target={triggerReference.current}
          directionalHint={DirectionalHint.rightCenter}
          onDismiss={onCloseModal}
        >
          <IncidentCreateModal
            selectedStartDate={value}
            onClose={onCloseModal}
            startDateReadOnly
          />
        </Callout>
      )}
      {isShowMorePopupOpenAndDateCorrect && (
        <Callout
          target={triggerReference.current}
          directionalHint={DirectionalHint.rightCenter}
          onDismiss={onCloseModal}
        >
          <IncidentShowMoreModal />
        </Callout>
      )}
    </div>
  );
});
